import { useState } from "react"

//components
import { Button } from "primereact/button"
import PromptButton from "../PromptButton"
import TemplateButton from "../TemplateButton"
import KBButton from "../KBButton"

const SetupButton = ()=>{
    const [showPages, setShowPages] = useState(false)

    const handlePage = (e)=>{
        e.preventDefault()
        if(!showPages){
            setShowPages(true)
        }else{
            setShowPages(false)
        }
        
    }
    return (        
        <>
            <Button onClick={handlePage}>Configurazione <i className='pi pi-sort-down-fill' style={{marginLeft:'10px'}}></i> </Button>
            {
                showPages && (
                    <div className="setupButton__ShowButtons">
                        <PromptButton/>
                        <TemplateButton/>
                        <KBButton/>
                    </div>
                )
            }
        </>
    )
}

export default SetupButton